// extracted by css-extract-rspack-plugin
export default {"root":"HeaderWrapper_root__nN2rS","draggableHeader":"HeaderWrapper_draggableHeader__fss7I"};